import { OUTLET_TYPES } from '../config';

const defaultOutletVisibility = {
  [OUTLET_TYPES.ASSIGNED]: true,
  [OUTLET_TYPES.UNASSIGNED]: false,
  [OUTLET_TYPES.OTHER]: false,
};

export { defaultOutletVisibility };
